import styled from "styled-components";

export const RichTextEditorContainer = styled.div.attrs({
  className: "rich-text-editor-container",
})`
  width: 100%;

  .public-DraftEditor-content {
    min-height: 15rem;
  }

  .EditorToolbar__root___3_Aqz,
  .RichTextEditor__root___2QXK- {
    font-family: var(--fontFamily);
  }

  .RichTextEditor__editor___1QqIU .public-DraftEditor-content,
  .RichTextEditor__editor___1QqIU .public-DraftEditorPlaceholder-root {
    padding: 1rem;
  }

  span:focus {
    background: red;
  }
`;
